const selectRepresentingOptions = [
  {
    id: 'ADVISOR_CONCILMAN',
    name: 'Assessor(a) de Vereador(a)',
    active: true,
    product: 'vereador(a)',
  },
  {
    id: 'ADVISOR_MAYOR',
    name: 'Assessor(a) de Prefeito(a)',
    active: true,
    product: 'prefeito(a)',
  },
  {
    id: 'ADVISOR_DEPUTY',
    name: 'Assessor(a) de Deputado(a)',
    active: true,
    product: 'deputado(a)',
  },

  {
    id: 'CHIEF_OF_STAFF_CONCILMAN',
    name: 'Chefe de Gabinete de Vereador(a)',
    active: true,
    product: 'vereador(a)',
  },
  {
    id: 'CHIEF_OF_STAFF_MAYOR',
    name: 'Chefe de Gabinete de Prefeito(a)',
    active: true,
    product: 'prefeito(a)',
  },
  {
    id: 'CHIEF_OF_STAFF_DEPUTY',
    name: 'Chefe de Gabinete de Deputado(a)',
    active: true,
    product: 'deputado(a)',
  },

  {
    id: 'CANDIDATE_CONCILMAN',
    name: 'Candidato a Vereador(a)',
    active: false,
    product: 'vereador(a)',
  },
  {
    id: 'CANDIDATE_MAYOR',
    name: 'Candidato a Prefeito(a)',
    active: false,
    product: 'prefeito(a)',
  },
  {
    id: 'CANDIDATE_DEPUTY',
    name: 'Candidato a Deputado(a)',
    active: false,
    product: 'deputado(a)',
  },

  {
    id: 'CONCILMAN',
    name: 'Vereador(a)',
    active: true,
    product: 'vereador(a)',
  },
  {
    id: 'MAYOR',
    name: 'Prefeito(a)',
    active: true,
    product: 'prefeito(a)',
  },
  {
    id: 'DEPUTY',
    name: 'Deputado(a)',
    active: true,
    product: 'deputado(a)',
  },

  {
    id: 'OTHER',
    name: 'Outro',
    active: true,
    product: 'vereador(a) ou prefeito(a) ou deputado(a)',
  },
];

export default selectRepresentingOptions;
